<template>
  <v-app>
  <v-navigation-drawer v-if="$route.name != 'Login'" app v-model="drawer">
    <v-list dense class="pt-0">
      <v-list-tile
        v-for="item in menuItems"
        :key="item.title"
        @click=$router.push(item.path)
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $vuetify.t(item.title) }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <v-toolbar dark app v-if="$route.name != 'Login'">
    <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    <v-toolbar-title class="white--text">Lobis Böden     {{ $vuetify.t('$vuetify.lobis.orders') }}</v-toolbar-title>

  </v-toolbar>
  <v-content>
    <v-container fluid>
      <router-view></router-view>
    </v-container>
  </v-content>
  <v-footer app></v-footer>
</v-app>

</template>

<script>
import { USER_REQUEST } from './store/actions/user'
// import webpush from './utils/webpush'

export default {
  name: 'App',
  data: () => ({
    drawer: null,
    items: [
      {
        title: '$vuetify.lobis.orders',
        icon: 'note_add',
        path: '/',
        permission: 'fe_orders'
      },
      {
        title: '$vuetify.lobis.history',
        icon: 'history',
        path: '/history',
        permission: 'fe_history'
      },
      // {
      //   title: '$vuetify.lobis.manualEntry',
      //   icon: 'border_color',
      //   path: '/timeentry',
      //   permission: 'fe_manualentry'
      // },
      {
        title: '$vuetify.lobis.workreport',
        icon: 'mdi-clipboard-alert',
        path: '/regie',
        permission: 'fe_workreport'
      },
      {
        title: '$vuetify.lobis.planner',
        icon: 'mdi-calendar',
        path: '/planner',
        permission: 'fe_planner'
      },
      {
        title: '$vuetify.lobis.billinglist',
        icon: 'straighten',
        path: '/billinglist',
        permission: 'fe_billinglist'
      },
      {
        title: '$vuetify.lobis.settings',
        icon: 'mdi-settings',
        path: '/settings',
        permission: 'fe_settings'
      },
      {
        title: 'Abrechnung',
        icon: 'credit_card',
        path: '/billing',
        permission: 'fe_billing'
      },
      {
        title: 'Serviceanrufe',
        icon: 'phone',
        path: '/calls',
        permission: 'fe_service'
      },
      {
        title: 'Kundenhistory',
        icon: 'phone',
        path: '/customerhistory',
        permission: 'fe_service'
      },
      {
        title: 'Teammeetings',
        icon: 'mdi-clipboard',
        path: '/teammeetings',
        permission: 'fe_settings'
      }
    ]
  }),
  computed: {
    menuItems () {
      return this.items.filter((menuItem) => {
        return this.$store.getters.hasPermission(menuItem.permission)
      })
    }
  },
  created () {
    this.$store.dispatch(USER_REQUEST)
    // webpush()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.navigation {
  margin-bottom: 20px;
  background-color: #000 !important
}
</style>



// WEBPACK FOOTER //
// src/App.vue